import React, { useState } from 'react';
import { Layout, Modal } from 'antd';
import LeftBar from '../Organism/LeftBar';
import AppHeaderTemplate2 from '../Organism/AppHeaderTemplate2';
import UserGrid from '../Templates/UserGrid';
import Progress from '../Molecules/Progress';

const Stackranking = () => {
    const [selectedStep, setSelectedStep] = useState(0);

    const verticalMenuItems = [
        { key: '1', title: 'ACE - Individual Awards', path: '/review/stack/individual' },
        { key: '2', title: 'ACE - Team Awards', path: '/review/stack/team' },
    ];

    const handleStepClick = (step: number) => {
        setSelectedStep(step);
    };
    const [collapsed, setCollapsed] = React.useState(false);
        // Sidebar width
    const sidebarWidth = collapsed ? 60 : 200;

    return (
        <div>
            <Layout style={{ minHeight: '100vh', display: 'flex' }}>
                <div className={`review-leftbar${collapsed ? ' collapsed' : ''}`}
                style={{
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    height: '100vh',
                    backgroundColor: 'purple',
                    zIndex: 1000,
                    transition: 'width 0.2s, left 0.2s',
                    width: sidebarWidth,
                }}>
                    {/* Pass collapsed and setCollapsed to LeftBar */}
                    <LeftBar menuItems={verticalMenuItems} collapsed={collapsed} setCollapsed={setCollapsed} />
                </div>
                <div className="review-main"
                style={{
                    marginLeft: sidebarWidth,
                    flex: '1',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'margin-left 0.2s',
                    minHeight: '100vh',
                    position: 'relative',
                    background: '#fff', // optional, for contrast
                }}>
                    <AppHeaderTemplate2 subtitle={'ELT Calibration'} />
                    <div style={{ marginLeft: '30px', marginTop: '10px' }}>
                        <Progress currentStage={4} onStepClick={handleStepClick} />
                    </div>
                    <UserGrid stage={'6'} />
                </div>
                <style>
                {`
                @media (max-width: 768px) {
                    .review-main {
                        margin-left: 0 !important;
                    }
                    .review-leftbar {
                        width: 60px !important;
                        left: -60px !important; /* Hide sidebar by default on mobile */
                    }
                    .review-leftbar.collapsed {
                        left: 0 !important; /* Show sidebar when not collapsed */
                    }
                }
                `}
            </style>
            </Layout>
        </div>
    );
};

export default Stackranking;